import {backendUrl} from "@shared/constants/urls/appUrls";

export const apiEndpoints = {
    forecasters: `${backendUrl}/api/forecasters/`,
    bookmarks: `${backendUrl}/api/forecasters/bookmark/`
    // anotherEndpoint: `${backendUrl}/api/another/`,
};

export const requestOptions = {
    get: {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    },
    post: {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    },
    delete: {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    },
};
